import Vue from 'vue';
import VModal from 'vue-js-modal'
import './core/bugsnag';
import Form from './core/Form';

Vue.use(VModal);
Vue.component('loading', require('./components/Loading').default);
Vue.component('send-user-message', require('./components/SendUserMessage').default);

new Vue({
    el: '#profile',

    data() {
        return {
            isLoading: false,
            messageHasBeenSent: false,
            userId: null,
            leaveFeedbackForm: new Form({
                'comment': '',
                'profile_id': null,
                'is_positive': true,
            }),
        };
    },

    beforeMount() {
        this.userId = parseInt(this.$el.attributes['data-user-id'].value);
    },

    methods: {
        submitLeaveFeedback() {
            this.isLoading = true;
            this.leaveFeedbackForm.data.profile_id = this.userId;

            this.leaveFeedbackForm.submit('post', route('profile.leave-feedback'))
                .then(() => this.$modal.hide('leave-feedback'))
                .catch(error => console.log(error))
                .finally(() => this.isLoading = false);
        },
    },
});
